import { Card, Collapse } from "@mui/material";
import CardBody from "../../../../../components/Card/CardBody";
import FormTextTC from "../../../../../components/Forms/FormTextTC";
import React from "react";
import { ArrangementVariant } from "../General";
import FormCustomizableTextTC from "../../../../../components/Forms/FormCustomizableTextTC";
import { useWatch } from "react-hook-form";
import { getTranslation } from "../../../../../components/TranslationWrapper/TranslationWrapper";

export function PreDiningArrangement({ variant }: { variant: ArrangementVariant }) {
  const id = useWatch({ name: "id" });

  return (
    <Collapse in={variant === "pre-dining"}>
      <Card>
        <CardBody>
          The pre-dining arrangement can be attached to tables, zones and salesareas. If a pre-dining arrangement is
          found for a given dining session, all products and items attached to the arrangement can be ordered before a
          primary arrangement is added to the table.
          <br />
          <FormTextTC
            name={"name"}
            rules={{
              required: true,
            }}
            tDefault={"Name"}
            tKey={"arrangements.name"}
          />
          <FormCustomizableTextTC
            inputProps={{
              disabled: id == null,
              helperText:
                id == null
                  ? getTranslation(
                      "forms.arrangement.pre-dining.text-shown-to-user.helper",
                      "Please save the arrangement to edit this text"
                    )
                  : "",
            }}
            model={"arrangement"}
            modelId={id}
            tDefault={"Pre dining text shown to user"}
            tKey={"form.arrangements.pre-dining.pre-dining-text"}
            translatableText={"Arrangements - Pre dining text"}
          />
        </CardBody>
      </Card>
    </Collapse>
  );
}
